module.exports = __webpack_public_path__ + "img/2_137.09b0f5d4.png";